import { EnergieEnum } from '../../../pages/rt2012/suivi-des-consommations/enums/EnergieEnum';
import { AbstractConsommationEnergie } from './abstract-consommation-energie';
import { format } from 'date-fns';
import {
  getGrapheTypeEnumName,
  GrapheTypeEnum
} from '../../../pages/rt2012/suivi-des-consommations/enums/GrapheTypeEnum';

export class ConsommationEnergieByDay extends AbstractConsommationEnergie {

  public distribute(selectedEnergie: EnergieEnum): any {
    const consommations = {};

    for (const consommation of this.consommations) {

      const date = new Date(consommation.date);

      if (this.checkDate(date)) {
        if (typeof consommations[date.getFullYear()] === 'undefined') {
          consommations[date.getFullYear()] = {};
        }

        if (typeof consommations[date.getFullYear()][date.getMonth()] === 'undefined') {
          consommations[date.getFullYear()][date.getMonth()] = {};
        }

        if (typeof consommations[date.getFullYear()][date.getMonth()][date.getDate()] === 'undefined') {
          consommations[date.getFullYear()][date.getMonth()][date.getDate()] = [];
        }

        if (selectedEnergie === consommation.energie) {
          consommations[date.getFullYear()][date.getMonth()][date.getDate()].push({
            name: consommation.energie,
            value: consommation.value
          });
        }
      }
    }

    return Object.keys(consommations)
      .sort((a, b) => parseInt(a, 0) > parseInt(b, 0) ? 1 : -1)
      .map(year => {
        return Object.keys(consommations[year])
          .sort((a, b) => parseInt(a, 0) > parseInt(b, 0) ? 1 : -1)
          .map(month => {
            return Object.keys(consommations[year][month])
              .sort((a, b) => parseInt(a, 0) > parseInt(b, 0) ? 1 : -1)
              .map(day => {
                const date = new Date(
                  parseInt(year, 0),
                  parseInt(month, 0),
                  parseInt(day, 0)
                );
                return {
                  name: getGrapheTypeEnumName(this.locale, GrapheTypeEnum.JOUR, date),
                  series: [].concat(consommations[year][month][day])
                };
              });
          });
      }).flat(2);
  }

  private checkDate(date: Date): boolean {
    return parseInt(format(date, 'yyyyMMdd'), 0) >= parseInt(format(this.fromDate, 'yyyyMMdd'), 0)
      && parseInt(format(date, 'yyyyMMdd'), 0) <= parseInt(format(this.toDate, 'yyyyMMdd'), 0);
  }
}
